export default __webpack_public_path__ + "static/media/icon-send-disabled.4b785578.svg";